import { render, staticRenderFns } from "./NewKeywordDiscoveryModal.vue?vue&type=template&id=9ad83248&scoped=true"
import script from "./NewKeywordDiscoveryModal.vue?vue&type=script&lang=js"
export * from "./NewKeywordDiscoveryModal.vue?vue&type=script&lang=js"
import style0 from "./NewKeywordDiscoveryModal.vue?vue&type=style&index=0&id=9ad83248&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad83248",
  null
  
)

export default component.exports